import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function OrderForm({ isEmbedded = false }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(null);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    // In a real app, this would be an API call
    const mockForms = [
      {
        id: 1,
        name: 'Order Form 1',
        packages: [
          { id: 1, name: 'PAKEJ A', description: '1 Kotak', price: 60, originalPrice: 70 },
          { id: 2, name: 'PAKEJ B', description: '2 Kotak', price: 100, originalPrice: 240 },
        ],
        fields: [
          { id: 'name', label: 'Nama', type: 'text', required: true },
          { id: 'phone', label: 'No Phone', type: 'tel', required: true },
          { id: 'address', label: 'Alamat', type: 'textarea', required: true },
        ],
        thankYouUrl: '/terima-kasih-1'
      },
    ];

    const foundForm = mockForms.find(f => f.id === parseInt(id));
    if (foundForm) {
      setForm(foundForm);
      const initialData = {};
      foundForm.fields.forEach(field => {
        initialData[field.id] = '';
      });
      initialData.package = '';
      initialData.paymentMethod = '';
      setFormData(initialData);
    }
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    
    if (isEmbedded) {
      window.parent.postMessage({
        type: 'FORM_SUBMITTED',
        data: formData
      }, '*');
    }
    
    navigate(form.thankYouUrl);
  };

  if (!form) return <div>Loading...</div>;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={`max-w-2xl ${!isEmbedded ? 'mx-auto' : ''}`}
    >
      <div className="bg-gray-800 text-white p-4 rounded-t-lg">
        <h1 className="text-xl font-bold text-center">BORANG TEMPAHAN</h1>
      </div>

      <form onSubmit={handleSubmit} className="bg-white rounded-b-lg shadow-md p-6">
        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-4">PILIH PAKEJ PROMO ANDA 👇</h2>
          <div className="space-y-4">
            {form.packages.map((pkg) => (
              <label
                key={pkg.id}
                className="block bg-white border rounded-lg p-4 cursor-pointer hover:border-blue-500"
              >
                <div className="flex items-center">
                  <input
                    type="radio"
                    name="package"
                    value={pkg.id}
                    onChange={(e) => setFormData({...formData, package: e.target.value})}
                    className="mr-3"
                  />
                  <div className="flex-1">
                    <div className="font-semibold">{pkg.name}</div>
                    <div className="text-sm text-gray-600">{pkg.description}</div>
                  </div>
                  <div className="text-right">
                    <div className="line-through text-gray-400">RM{pkg.originalPrice.toFixed(2)}</div>
                    <div className="text-red-500 font-bold">RM{pkg.price.toFixed(2)}</div>
                  </div>
                </div>
              </label>
            ))}
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-4">MAKLUMAT PENGHANTARAN 👇</h2>
          <div className="space-y-4">
            {form.fields.map((field) => (
              <div key={field.id}>
                <label className="block text-gray-700 mb-2">
                  {field.label}
                  {field.required && <span className="text-red-500">*</span>}
                </label>
                {field.type === 'textarea' ? (
                  <textarea
                    required={field.required}
                    className="w-full p-2 border rounded"
                    onChange={(e) => setFormData({...formData, [field.id]: e.target.value})}
                    value={formData[field.id] || ''}
                    placeholder={`Masukkan ${field.label}`}
                  />
                ) : (
                  <input
                    type={field.type}
                    required={field.required}
                    className="w-full p-2 border rounded"
                    onChange={(e) => setFormData({...formData, [field.id]: e.target.value})}
                    value={formData[field.id] || ''}
                    placeholder={`Masukkan ${field.label}`}
                  />
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-4">PILIH CARA BAYARAN 👇</h2>
          <div className="space-y-4">
            <label className="block bg-white border rounded-lg p-4 cursor-pointer hover:border-blue-500">
              <div className="flex items-center">
                <input
                  type="radio"
                  name="payment"
                  value="online"
                  onChange={(e) => setFormData({...formData, paymentMethod: e.target.value})}
                  className="mr-3"
                />
                <span>Online Banking</span>
              </div>
            </label>
            <label className="block bg-white border rounded-lg p-4 cursor-pointer hover:border-blue-500">
              <div className="flex items-center">
                <input
                  type="radio"
                  name="payment"
                  value="cod"
                  onChange={(e) => setFormData({...formData, paymentMethod: e.target.value})}
                  className="mr-3"
                />
                <span>Bayar Pada Posmen</span>
              </div>
            </label>
          </div>
        </div>

        <button
          type="submit"
          className="w-full bg-blue-500 text-white py-3 rounded-lg hover:bg-blue-600"
        >
          Hantar Order! →
        </button>

        <p className="text-center text-sm text-gray-500 mt-4">
          * Ruangan yang wajib diisi
        </p>
      </form>
    </motion.div>
  );
}